module.exports = __webpack_public_path__ + "static/media/upload.0ba44e4f.svg";